/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';
import { ItnlIntegrationScript } from '@/data/types/ItnlIntegrationScript';
import { WidgetProperties } from '@/data/types/Slot';
import { flowboxScript } from '@/utils/itnlIntegrationScriptsScripts';
import { loadExternalScripts, removeScripts } from '@/utils/loadExternalScripts';
import { Box } from '@mui/material';
import { usePathname } from 'next/navigation';
import { FC, useEffect } from 'react';

const emptyProperties = {} as WidgetProperties;
const page = "PLP";

export const FlowboxPlpRv: FC<{ id: ID; properties?: WidgetProperties }> = ({
	id: _id,
	properties = emptyProperties,
}) => {
	const flowboxDynamicTagKey = properties.flowKey || properties.flowboxDynamicPDPKey;//flowboxDynamicPDPKey is the variable recieved from commerce composer layouts
	const currentPath = usePathname();
	const categoryArray = currentPath?.split('/')??[currentPath];
	const arraySize = categoryArray.length;
	const category =  categoryArray?.at(arraySize-1)?.trim();
	
	useEffect(() => {
		if (flowboxDynamicTagKey && category) {
			let scripts: ItnlIntegrationScript[] = [{
				id: "flowbox_init_script",
				scriptContent: flowboxScript(flowboxDynamicTagKey, page, category),
			}];

			loadExternalScripts(scripts);
			return () => { removeScripts(scripts) }
		}
	}, [flowboxDynamicTagKey, category]);

	return (
			<Box id="js-flowbox-flow" className="flowBoxDiv" ></Box>
	);
};